document.addEventListener("DOMContentLoaded", () => {
  const BundleShared = window.BundleShared;
  if (!BundleShared) {
    console.error("BundleShared helper is required before this script.");
    return;
  }

  const {
    addItemsToCart,
    areAllBundleSlotsFilled,
    buildRechargeBundleLineItem,
    getActiveBundleGroupFromSection,
    getCurrentPurchaseType,
    getFirstIncompleteBundleSlot,
    openPopup,
  } = BundleShared;

  const purchaseBtns = document.querySelectorAll(".purchase-type");
  const oneTimeSection = document.querySelector(".one-time-bundle");
  const subscriptionSection = document.querySelector(".subscription-bundle");
  const frequencySelector = document.querySelector("[data-frequency-selector]");

  function getBundleSectionByPurchaseType(type = getCurrentPurchaseType()) {
    return type === "one-time" ? oneTimeSection : subscriptionSection;
  }

  function getBundleGroupBySet(targetSet, sectionEl = subscriptionSection) {
    if (!sectionEl || !targetSet) return null;

    return sectionEl.querySelector(
      `.bundle-group[data-bundle-set="${targetSet}"]`,
    );
  }

  function normalizeBundleSet(targetSet = "") {
    const setMatch = String(targetSet || "").match(/\d+/);
    return setMatch ? `set-${setMatch[0]}` : String(targetSet || "");
  }

  function getBundlePricingFromElement(priceEl, targetSet) {
    const normalizedSet = normalizeBundleSet(targetSet);
    const setNumber = normalizedSet.match(/\d+/)?.[0];

    if (!priceEl || !setNumber) return null;

    const price =
      priceEl.dataset[`priceSet${setNumber}`] ||
      priceEl.getAttribute(`data-price-set-${setNumber}`) ||
      priceEl.getAttribute(`data-price-set${setNumber}`) ||
      "";
    const compare =
      priceEl.dataset[`compareSet${setNumber}`] ||
      priceEl.getAttribute(`data-compare-set-${setNumber}`) ||
      priceEl.getAttribute(`data-compare-set${setNumber}`) ||
      "";

    if (!price && !compare) return null;

    return { price, compare, set: normalizedSet };
  }

  function getSavedPercentageTargets(priceSpan) {
    const sectionScope = priceSpan.closest(
      ".one-time-bundle, .subscription-bundle",
    );
    const scopedTargets = sectionScope
      ? Array.from(sectionScope.querySelectorAll("[data-saved-percentage]"))
      : [];

    return scopedTargets.length
      ? scopedTargets
      : Array.from(document.querySelectorAll("[data-saved-percentage]"));
  }

  function updateSavedPercentage(priceSpan, price, compare) {
    const cleanPrice = parseFloat(String(price || "").replace(/[^0-9.]/g, ""));
    const cleanCompare = parseFloat(
      String(compare || "").replace(/[^0-9.]/g, ""),
    );

    if (!cleanPrice || !cleanCompare || cleanCompare <= cleanPrice) return;

    const discount = ((cleanCompare - cleanPrice) / cleanCompare) * 100;
    const formattedDiscount = Math.round(discount);

    getSavedPercentageTargets(priceSpan).forEach((el) => {
      el.textContent = `${formattedDiscount}%`;
    });
  }

  function getCurrentActiveSet(sectionEl = getBundleSectionByPurchaseType()) {
    return (
      sectionEl?.querySelector(".bundle-group.active")?.dataset.bundleSet ||
      sectionEl?.querySelector(".bundle-option.active")?.dataset.target ||
      `set-${document.querySelector("[data-bundle-price]")?.dataset.defaultSet || 1}`
    );
  }

  function activateBundleSet(
    targetSet,
    sectionEl = getBundleSectionByPurchaseType(),
  ) {
    if (!sectionEl || !targetSet) return;

    sectionEl.querySelectorAll(".bundle-option").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.target === targetSet);
    });

    sectionEl
      .querySelectorAll(".bundle-group[data-bundle-set]")
      .forEach((group) => {
        const isActive = group.dataset.bundleSet === targetSet;
        group.classList.toggle("active", isActive);
        group.classList.toggle("hidden", !isActive);
      });
  }

  function setSellingPlanOnGroup(targetSet, sellingPlanId) {
    const group = getBundleGroupBySet(targetSet, subscriptionSection);
    if (!group) return;

    if (sellingPlanId) {
      group.dataset.sellingPlan = sellingPlanId;
    } else {
      group.removeAttribute("data-selling-plan");
    }
  }

  function syncBundleSet(targetSet) {
    if (!targetSet) return;

    activateBundleSet(targetSet, oneTimeSection);
    activateBundleSet(targetSet, subscriptionSection);

    updateBundleDisplay(targetSet, { purchaseType: getCurrentPurchaseType() });

    // Always update subscription frequency too,
    // even if the user clicked the one-time bundle option.
    renderFrequencyOptionsForSet(targetSet);
  }

  function renderFrequencyOptionsForSet(targetSet) {
    if (!frequencySelector) return;

    const template = document.querySelector(
      `[data-frequency-template="${targetSet}"]`,
    );
    const group = getBundleGroupBySet(targetSet, subscriptionSection);

    if (!template || !group) {
      frequencySelector.innerHTML = "";
      frequencySelector.disabled = true;
      return;
    }

    const savedValue =
      group.dataset.sellingPlan || template.dataset.defaultSellingPlan || "";

    frequencySelector.innerHTML = template.innerHTML.trim();

    const options = Array.from(frequencySelector.options);
    const hasSavedValue = options.some((option) => option.value === savedValue);

    if (hasSavedValue) {
      frequencySelector.value = savedValue;
    } else if (options.length > 0) {
      frequencySelector.selectedIndex = 0;
    }

    frequencySelector.disabled = options.length === 0;

    setSellingPlanOnGroup(targetSet, frequencySelector.value);
  }

  const updateBundleDisplay = (
    targetSet,
    { purchaseType = getCurrentPurchaseType() } = {},
  ) => {
    const normalizedSet = normalizeBundleSet(targetSet);

    document.querySelectorAll("[data-bundle-price]").forEach((priceSpan) => {
      const pricing = getBundlePricingFromElement(priceSpan, normalizedSet);

      if (!pricing) return;

      priceSpan.innerHTML = pricing.compare
        ? `${pricing.price} <s>${pricing.compare}</s>`
        : pricing.price;

      priceSpan.dataset.currentBundleSet = normalizedSet;
      priceSpan.dataset.currentPurchaseType = priceSpan.closest(
        ".one-time-bundle",
      )
        ? "one-time"
        : priceSpan.closest(".subscription-bundle")
          ? "subscription"
          : purchaseType;

      updateSavedPercentage(priceSpan, pricing.price, pricing.compare);
    });

    document.dispatchEvent(
      new CustomEvent("bundle:price-updated", {
        detail: {
          set: normalizedSet,
          purchaseType,
        },
      }),
    );
  };

  window.updateBundleDisplay = updateBundleDisplay;
  window.bundleCart_syncBundleSet = syncBundleSet;

  purchaseBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const type = btn.dataset.type || getCurrentPurchaseType();
      const sectionEl = getBundleSectionByPurchaseType(type);
      const activeSet = getCurrentActiveSet(sectionEl);

      updateBundleDisplay(activeSet, { purchaseType: type });

      if (type === "subscription") {
        renderFrequencyOptionsForSet(activeSet);
      }
    });
  });

  function getSelectedSubscriptionUpsells() {
    return Array.from(
      document.querySelectorAll("[data-subscription-upsell-checkbox]:checked"),
    )
      .map((checkbox) => ({
        id: Number(checkbox.dataset.variantId),
        productId: String(checkbox.dataset.productId || ""),
        title: checkbox.dataset.title || "",
      }))
      .filter((upsell) => upsell.id);
  }

  function getSelectedOneTimeUpsells() {
    return Array.from(
      document.querySelectorAll("[data-onetime-upsell-checkbox]:checked"),
    )
      .map((checkbox) => ({
        id: Number(checkbox.dataset.variantId),
        productId: String(checkbox.dataset.productId || ""),
        title: checkbox.dataset.title || "",
      }))
      .filter((upsell) => upsell.id);
  }

  function resetSubscriptionUpsells() {
    document
      .querySelectorAll("[data-subscription-upsell-checkbox]:checked")
      .forEach((checkbox) => {
        checkbox.checked = false;
        checkbox
          .closest("[data-subscription-upsell-item]")
          ?.classList.remove("is-selected");
      });
  }

  function resetOneTimeUpsells() {
    document
      .querySelectorAll("[data-onetime-upsell-checkbox]:checked")
      .forEach((checkbox) => {
        checkbox.checked = false;
        checkbox
          .closest("[data-onetime-upsell-item]")
          ?.classList.remove("is-selected");
      });
  }

  document
    .querySelectorAll("[data-subscription-upsell-checkbox]")
    .forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const item = checkbox.closest("[data-subscription-upsell-item]");
        if (!item) return;

        item.classList.toggle("is-selected", checkbox.checked);
      });
    });

  document
    .querySelectorAll("[data-onetime-upsell-checkbox]")
    .forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const item = checkbox.closest("[data-onetime-upsell-item]");
        if (!item) return;

        item.classList.toggle("is-selected", checkbox.checked);
      });
    });

  document.querySelectorAll(".bundle-selector").forEach((selector) => {
    const buttons = selector.querySelectorAll(".bundle-option");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetSet = btn.dataset.target;

        syncBundleSet(targetSet);
      });
    });
  });

  if (frequencySelector) {
    frequencySelector.addEventListener("change", () => {
      const activeSet = getCurrentActiveSet(subscriptionSection);
      setSellingPlanOnGroup(activeSet, frequencySelector.value);
    });
  }

  const priceSpan = document.querySelector("[data-bundle-price]");
  if (priceSpan) {
    const defaultSet = priceSpan.dataset.defaultSet;
    const defaultTarget = `set-${defaultSet}`;

    syncBundleSet(defaultTarget);
  }

  function openBundlePickerBeforeCart(groupEl) {
    const firstIncompleteSlot = getFirstIncompleteBundleSlot(groupEl);

    if (window.bundlePopup_openSlot) {
      window.bundlePopup_openSlot(firstIncompleteSlot);
      return;
    }

    if (firstIncompleteSlot) {
      firstIncompleteSlot.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );
      return;
    }

    openPopup("bundle-collection-popup");
  }

  function getOneTimeGiftSelection() {
    const oneTimeGiftEl = document.querySelector(".one-time-gift");

    const giftCollectionId = oneTimeGiftEl?.dataset.otCollectionId;
    const giftProductId = oneTimeGiftEl?.dataset.otProductId;
    const giftVariantId = oneTimeGiftEl?.dataset.otVariantId;
    const giftTitle = oneTimeGiftEl?.dataset.otGiftTitle || "Gift";

    if (!giftCollectionId || !giftProductId || !giftVariantId) return null;

    return {
      collectionId: String(giftCollectionId),
      externalProductId: String(giftProductId),
      externalVariantId: String(giftVariantId),
      title: giftTitle,
    };
  }

  function getSelectedUpsells(isSubscription) {
    return isSubscription
      ? getSelectedSubscriptionUpsells()
      : getSelectedOneTimeUpsells();
  }

  async function buildBundleFromGroup(
    activeGroup,
    isSubscription = true,
    options = {},
  ) {
    const { redirectToCheckout = false } = options;

    if (!activeGroup) {
      alert("Please select a bundle first.");
      return false;
    }

    if (!areAllBundleSlotsFilled(activeGroup)) {
      openBundlePickerBeforeCart(activeGroup);
      return false;
    }

    const extraSelections = [];
    if (!isSubscription) {
      const giftSelection = getOneTimeGiftSelection();
      if (giftSelection) extraSelections.push(giftSelection);
    }

    const bundleResult = await buildRechargeBundleLineItem({
      groupEl: activeGroup,
      isSubscription,
      extraSelections,
      rechargeMissingMessage: "Recharge bundle is not ready yet.",
    });

    if (!bundleResult) return false;

    const finalItems = [bundleResult.parentItem];
    const selectedUpsells = getSelectedUpsells(isSubscription);

    selectedUpsells.forEach((upsell) => {
      finalItems.push({
        id: upsell.id,
        quantity: 1,
        properties: {
          _bundle_upsell: "true",
          _bundle_parent_variant: String(bundleResult.parentVariantId),
        },
      });
    });

    console.log(
      `➕ ${isSubscription ? "Subscription" : "One-time"} upsells added:`,
      selectedUpsells,
    );

    try {
      const res = await addItemsToCart(finalItems);

      if (!res.ok) {
        console.error("❌ Add-to-cart error:", res);
        alert("Error adding bundle to cart.");
        return false;
      }

      console.log("✅ Bundle successfully added");

      if (isSubscription) {
        resetSubscriptionUpsells();
      } else {
        resetOneTimeUpsells();
      }

      if (redirectToCheckout) {
        window.location.href = "/checkout";
      }

      return true;
    } catch (err) {
      console.error("❌ Fetch error:", err);
      alert("Something went wrong. Please try again.");
      return false;
    }
  }

  async function buildBundle(
    groupSelector,
    isSubscription = true,
    options = {},
  ) {
    const activeGroup = getActiveBundleGroupFromSection(groupSelector);

    return buildBundleFromGroup(activeGroup, isSubscription, options);
  }

  window.buildRechargeBundle = async function ({
    redirectToCheckout = false,
  } = {}) {
    const purchaseType = getCurrentPurchaseType();

    if (purchaseType === "one-time") {
      const activeGroup = getActiveBundleGroupFromSection(oneTimeSection);

      return buildBundleFromGroup(activeGroup, false, {
        redirectToCheckout,
      });
    }

    const activeGroup = getActiveBundleGroupFromSection(subscriptionSection);

    return buildBundleFromGroup(activeGroup, true, {
      redirectToCheckout,
    });
  };

  const addOneTimeBtn = document.getElementById("add-bundle-onetime");
  if (addOneTimeBtn) {
    addOneTimeBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await buildBundle(oneTimeSection, false);
    });
  }

  const addSubscriptionBtn = document.getElementById("add-bundle-subscription");
  if (addSubscriptionBtn) {
    addSubscriptionBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      console.log("subscription ATC clicked");

      await buildBundle(subscriptionSection, true);
    });
  }
});
